export default {
  Filling: 1,
  Approved: 2
};
